import React from 'react';
import useApiClient from '../useApiClient';
import './MemoriesIndexScreen.css';

interface IMemoryWithVenue {
  id: number;
  venueId: number;
  content: string;
  userName: string;
  userEmail: string;
  isAnonymous: boolean;
  isDeleted: boolean;
  venue: { name: string };
}

const MemoriesIndexScreen: React.FC = () => {
  const { getApiClient } = useApiClient();
  const [memories, setMemories] = React.useState<IMemoryWithVenue[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [showDeleted, setShowDeleted] = React.useState(false);

  const fetchMemories = React.useCallback(async (includeDeleted: boolean) => {
    try {
      const client = await getApiClient();
      const response = await client.get<{ result: IMemoryWithVenue[] }>('/api/memory', {
        params: includeDeleted ? { includeDeleted: 'true' } : {},
      });
      setMemories(response.data.result);
    } catch (error) {
      console.error('Failed to fetch memories:', error);
    } finally {
      setIsLoading(false);
    }
  }, [getApiClient]);

  React.useEffect(() => {
    fetchMemories(showDeleted);
  }, [fetchMemories, showDeleted]);

  const handleDelete = async (id: number) => {
    if (!window.confirm('למחוק את הזיכרון הזה?')) {
      return;
    }
    try {
      const client = await getApiClient();
      await client.delete(`/api/memory/${id}`);
      if (showDeleted) {
        setMemories((prev) => prev.map((m) => m.id === id ? { ...m, isDeleted: true } : m));
      } else {
        setMemories((prev) => prev.filter((m) => m.id !== id));
      }
    } catch (error) {
      console.error('Failed to delete memory:', error);
    }
  };

  if (isLoading) {
    return <div>טוענת...</div>;
  }

  return (
    <>
      <div className="memoriesIndexScreen-header">
        <h1>ניהול זיכרונות</h1>
        <label style={{ marginRight: '16px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={showDeleted}
            onChange={(e) => setShowDeleted(e.target.checked)}
            style={{ marginLeft: '4px' }}
          />
          הצג מחוקים
        </label>
      </div>
      <table className="memoriesTable">
        <thead>
          <tr>
            <th>מקום</th>
            <th>שם</th>
            <th>אימייל</th>
            <th>תוכן</th>
            <th>ID</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {memories.map((memory) => (
            <tr key={memory.id} style={memory.isDeleted ? { opacity: 0.4, textDecoration: 'line-through' } : {}}>
              <td>{memory.venue?.name}</td>
              <td>{memory.isAnonymous ? '(אנונימי)' : memory.userName}</td>
              <td dir="ltr">{memory.userEmail}</td>
              <td className="memory-content" title={memory.content}>{memory.content}</td>
              <td>{memory.id}</td>
              <td>
                {!memory.isDeleted && (
                  <button className="delete-btn" onClick={() => handleDelete(memory.id)}>מחיקה</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default MemoriesIndexScreen;
